module.exports = __webpack_public_path__ + "img/photo_2022-10-26_22-17-01.b488de53.jpg";